import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Breadcrumb, Card } from 'antd'

import Wrapper from '@common/decorators/Wrapper';
import CheckPermissions from '@common/decorators/CheckPermissions';
import checkPermissions from '@common/utils/check/permissions';
import TableProcedure from '../components/TableProcedure';

import '../less/Affidamento.less';

@Wrapper({ route: 'GestioneFormulari', hasSidebar: true, hasHeader: true, hasFooter: true })
@CheckPermissions(['viewProcedura'])
class GestioneFormulariRoute extends Component {

  state = {
    loading: false,
    asked: false,
  }

  renderTitle() {
    return 'Gestione formulari'
  }

  render() {

    return (
      <div>
        <Card
          style={{ marginBottom: '12px', backgroundColor: '#fff' }}
          bordered={false}
          className="shadow">
          <h3 className="sectionTitle">{this.renderTitle()}</h3>
          {!checkPermissions.hasPermission( this.props.UserStore.user, ['entePermissions']) ? <p>Gestione formulari</p> : null}
        </Card>
        <div style={{ padding: '12px' }}>
          <Breadcrumb>
            <Breadcrumb.Item><Link to="/dashboard">Home</Link></Breadcrumb.Item>
            <Breadcrumb.Item>Gestione formulari</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <TableProcedure ref="listTable" {...this.props} />

      </div>
    );
  }
}

export default GestioneFormulariRoute;
